<script setup lang="ts">
import { NarrowedPremium, PolicyType } from "@/entities/premium";
import CompanyLogo from "../Shared/CompanyLogo.vue";
import { SCOTTISH_WIDOWS_ERROR_STATUS_CODE } from "@/constants/companyNames";

const props = defineProps<{
    premium: NarrowedPremium<PolicyType.Error>;
}>();

const statusCode = props.premium.policy.statusCode;
const company = props.premium.company;

</script>

<template>
    <div class="result-summary">
        <CompanyLogo :company-slug="company.slug" />
        <div class="result-error">
            <div id="quoteContainer">
                <template v-if="statusCode >= 200 && statusCode <= 299">
                    <h3>Not Available</h3>
                    <h6>{{ company.name }} was unable to return a quote.</h6>
                </template>
                <h6 v-else-if="statusCode >= 400 && statusCode <= 499">
                    {{ company.name }} could not return a quote at this time. Please try later.
                </h6>
                <h6 v-else-if="statusCode >= 500 && statusCode <= 599">
                    {{ company.name }} could not return a quote at this time. Please try later.
                </h6>
                <h6 v-else-if="statusCode === SCOTTISH_WIDOWS_ERROR_STATUS_CODE">
                    Scottish Widows is unable to return an online quote. If you would like a guaranteed quote to compare, please call Annuity Ready on <a href="tel:08003265479">0800 326 5479</a>.
                </h6>
                <h6 v-else>
                    {{ company.name }} could not return a quote.
                </h6>
            </div>
        </div>
    </div>
</template>

<style scoped>
.result-summary {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 12px;
    gap: 24px;
}
.result-error {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.result-error h3 {
    font-size: 24px;
}

@media (max-width: 992px) {
    .result-summary {
        flex-direction: column;
    }
}
</style>
